"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.client = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _hivemindSdkBrowser = _interopRequireWildcard(require("@godaddy/hivemind-sdk-browser"));
var _getShopperId = _interopRequireDefault(require("./getShopperId"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var client = exports.client = null;
var _default = exports.default = function _default(rootDomain) {
  var mock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mockCookie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!client) {
    var shopperId = mockCookie ? (0, _getShopperId.default)(mockCookie) : (0, _getShopperId.default)();
    var params = {
      app: 'modal_loader',
      subject: (0, _defineProperty2.default)({}, _hivemindSdkBrowser.hivemindConstants.idTypes.SHOPPER_ID, "".concat(shopperId))
    };
    if (mock) params.mockData = {}; // Hivemind won't make API calls when mocking

    exports.client = client = new _hivemindSdkBrowser.default(params);
  }
  return client;
};